export default __webpack_public_path__ + "static/media/278355259_100448642645093_2810449839741701144_n.a3afd048.jpg";